export const environment = {
    production: true,
    // baseURL: "https://mu-react-backend.herokuapp.com",
    // baseURL: "https://api-react-staging.mastersunion.org", // For Testing
    // baseURL: "https://apireact.mastersunion.org", // For Live
    // baseURL: "https://retoolapi.dev"
    // baseURL: "http://localhost:31350",
    baseURL: "https://epicapi.mastersunion.org"
};
